import { createReducer } from 'typesafe-actions';
import { AccountAction } from '@store/actions';
import { Account } from '@types';
import { fetchAccountAsync } from '@store/actions/accounts.action';

export interface AccountState {
    account: Account;
}

export const account: AccountState = {
    account: {} as Account
};

export const accountReducer = createReducer<AccountState, AccountAction>(account).handleAction(
    fetchAccountAsync.success,
    (state, action) => ({
        ...state,
        account: action.payload
    })
);
